import React from "react";
import Flex from "Trackalyze/Flex";
import Typo from "Trackalyze/Typo";
import { useTranslation } from "react-i18next";
import FilterGpxTypesContent from "./FilterGpxTypesContent";
import { ListItem } from "Trackalyze/List";

const FilterGpxTypes = ({ standalone }) => {
  const { t } = useTranslation();

  return standalone ? (
    <FilterGpxTypesContent standalone={standalone} />
  ) : (
    <>
      <ListItem>
        <Flex vertical spacing="3" padding="s">
          <Flex spacing="3" out itemscenter>
            <Typo type="label" size="l">
              {t("trackManager.filterOptionsGpxtypes")}
            </Typo>
          </Flex>
          <FilterGpxTypesContent />
        </Flex>
      </ListItem>
    </>
  );
};

export default React.memo(FilterGpxTypes);
